import IApiClient from "./ApiClient";
import {ZipCodeResponse} from "models/Location"
import { Location } from "models/Company";

export interface ILocationService {
  lookupzip(zipcode: string): Promise<ZipCodeResponse | undefined>;
  }

export default class LocationService implements ILocationService{
    apiBase: string;
    apiClient: IApiClient;
  
    constructor(apiClient: IApiClient) {
      this.apiBase = '/api/location';
      this.apiClient = apiClient;
    }
  
    async lookupzip(zipcode: string): Promise<ZipCodeResponse|undefined> {
      try {
        const response = await this.apiClient.get<ZipCodeResponse>(
          `${this.apiBase}/lookup/zip/${zipcode}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }

    async lookupid(id: string): Promise<Location|undefined> {
      try {
        const response = await this.apiClient.get<Location>(
          `${this.apiBase}/lookup/id/${id}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }
  }